export default __webpack_public_path__ + "019eb00f3b99fa0591d43093e4340130.png";